import Resource from '@/services/resources/common';

export default class ZoneTypeResource extends Resource {
  constructor(entrypoint = '/locations', alias = 'Location') {
    super(entrypoint, alias);
  }
}
